export default {"src":"/_next/static/media/technologies-logo-4.225f923d.svg","height":86,"width":86,"blurWidth":0,"blurHeight":0};